import { memo } from 'react'
// Components
import { Button, Tooltip, IconAddToFavoritesOutline, IconAddToFavoritesFilled } from '@tracklib/kit'

// Hooks
import { useRequest } from 'modules/requests/hooks'
import { useActions } from 'modules/audio/hooks'
import { useIsInFavoritesCollection } from 'modules/collections/hooks'

// Types
import { Loop } from 'types'

import styles from './addtofavoritesbutton.css'

type AddToFavoritesButtonProps = {
  trackId: number
  loop?: Loop | null
  className?: string
}

const AddToFavoritesButton = ({ trackId, loop, className }: AddToFavoritesButtonProps): JSX.Element => {
  const { handleAddToFavorites } = useActions()
  const isInFavorites = useIsInFavoritesCollection(+trackId, loop)

  const addRequest = useRequest('COLLECTION_ADD', String(trackId))
  const removeRequest = useRequest('COLLECTION_REMOVE', String(trackId))
  const request = isInFavorites ? removeRequest : addRequest

  const type = loop ? 'loop' : 'track'
  const title = isInFavorites || addRequest.isLoading ? `Remove ${type} from favorites` : `Add ${type} to favorites`

  return (
    <div data-tooltip-wrapper className={className}>
      <Tooltip>{title}</Tooltip>
      <Button
        datatesting="save_to_favorites_button"
        title={title}
        onClick={() => handleAddToFavorites(+trackId, loop)}
        disabled={request?.isLoading}
        spinnerBorderWidth={2}
        className={styles.button}
        variant="transparent"
      >
        {isInFavorites || addRequest.isLoading ? (
          <IconAddToFavoritesFilled className={styles.iconFilled} />
        ) : (
          <IconAddToFavoritesOutline className={styles.icon} />
        )}
      </Button>
    </div>
  )
}

export default memo(AddToFavoritesButton)
